import React from "react";
import { useTranslation } from "react-i18next";
import Box from "@mui/material/Box";
import Input from "react-currency-masked-input";

import { getLocalisationVal, transformInput } from "@/utils/localizationUtil";
import { Colors } from "@/theme";
import useStyles from "./styles";

const ProductCard = ({
  isLast,
  localization,
  product,
  newPrice,
  onChangePrice,
}) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const productPrice = product.prices?.[0]?.gross_price;

  return (
    <Box
      sx={{
        padding: "0px 40px 30px",
        borderRight: isLast ? "none" : `1px solid ${Colors.GRAY_BORDER}`,
      }}
    >
      <Box textAlign={"center"}>
        <span className={classes.codeText}>{product.product_code}</span>
      </Box>
      <Box mt={5} textAlign={"center"}>
        <span className={classes.inputLabel}>
          {t("manage_price_screen.current_price_margin")}
        </span>
      </Box>
      <Box mt={5} textAlign={"center"}>
        <span className={classes.codeText}>{`${getLocalisationVal(
          localization,
          productPrice
        )}p`}</span>
      </Box>
      <Box mt={5} textAlign={"center"}>
        <span className={classes.addressText}>
          {t("manage_price_screen.enter_new_price")}
        </span>
      </Box>
      <Box mt={2}>
        <Input
          value={getLocalisationVal(localization, newPrice)}
          onChange={(e, value) =>
            onChangePrice(transformInput(localization, value))
          }
          className={classes.currencyInput}
          type=""
          separator={localization.digit_separator === "," ? "." : ","}
        />
      </Box>
    </Box>
  );
};

export default ProductCard;
